import './Days.css'

import PropTypes from 'prop-types'
import React from 'react'
import { getMomentDate } from 'utils'

function Days({ dates }) {
  return (
    <div className="days">
      {dates.map(date => (
        <div key={date}>
          <div>{getMomentDate(date).format('ddd')}</div>
          <div>{getMomentDate(date).format('DD.MM')}</div>
        </div>
      ))}
    </div>
  )
}

Days.propTypes = {
  dates: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default Days
